import { render, staticRenderFns } from "./EduLevelManagement.vue?vue&type=template&id=3e81a025&"
import script from "./EduLevelManagement.vue?vue&type=script&lang=js&"
export * from "./EduLevelManagement.vue?vue&type=script&lang=js&"
import style0 from "./EduLevelManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports